/* eslint-disable react/no-array-index-key */
import React from 'react'
import Box from '@roo/roo/Box'
import Icon from '@roo/roo/Icon'
import Cascader from '@roo/roo/Cascader'
import { useTranslation } from '@sailor/i18n-web'
import styles from './index.module.less'
import PlusCircleSvg from '@/components/Icons/PlusCircleSvg'
import { warningToast } from '@/common/utils/toast'

const hourOptions = Array.from({ length: 24 }).map((_, i) => i.toString().padStart(2, '0')) // 自动生成00~23
const baseMinOptions = Array.from({ length: 60 }).map((_, i) => i.toString().padStart(2, '0')) // 自动生成00~59

const options = hourOptions.map(item => {
  const minOptions = baseMinOptions // 23点需要额外配置59
  return ({
    label: item,
    value: item,
    children: minOptions.map(min => ({
      label: min,
      value: min,
    })),
  })
})


const TimeSelector = (props: {

  /** 单条时间, 格式: 20:30 */
  value: string,
  onChange: (val: string) => void
}) => {
  const [hour = '', min = ''] = props.value?.split(':') || []
  const { t } = useTranslation()

  function handleChange ([newHour = '', newMin = '']: [newHour: string, newMin: string]) {
    props.onChange(`${newHour}:${newMin}`)
  }

  return (
    <Cascader
      style={{ width: '112px' }}
      value={[hour, min]}
      options={options}
      onChange={handleChange}
      clearable={false}
      suffixIcon={<Icon name="arrow-down" color="#5C5C5C" size={14} style={{ transform: 'translateY(-3px)' }}/>}
      displayRender={() => hour ? `${hour}:${min}` : ''}
      placeholder={t('mkt_tool_event_form_info_tiems_please_select')}
      placement={'bottomLeft'}
      dropdownClassName="ltr_wrapper"
    />
  )
}

const TimeRange = (props: {

  /** 单条时间段,例如[ 20:30, 20:40] */
  value: {
    startTime: string;
    endTime: string;

  },
  onChange: (val:  {
    startTime: string;
    endTime: string;

  }) => void,
  onDelete: () => void,
  onAdd: () => void,
  disableDelete: boolean,
  disableAdd: boolean,
}) => {
  const { startTime, endTime } = props.value || {}
  const { disableDelete, disableAdd } = props

  function handleChange (start = '', end = '') {
    let newStartTime = start
    let newEndTime = end
    if (newStartTime.length === 5 && newEndTime.length === 5 && (newStartTime > newEndTime)) { // 反向
      newStartTime = end
      newEndTime = start
    }
    props.onChange({ startTime: newStartTime, endTime: newEndTime })
  }
  return (
    <Box flexDirection="row" width="320px" className={styles.formTimeSelect} >
      <TimeSelector
        value={startTime}
        onChange={(newStartTime: string) => handleChange(newStartTime, endTime)}
      />
      <div style={{ padding: '0 8px', color: '#343434' }}>—</div>
      <TimeSelector
        value={endTime}
        onChange={(newEndTime: string) => handleChange(startTime, newEndTime)}
      />
      <Icon
        onClick={() => !disableAdd && props.onAdd()}
        style={{ marginLeft: '16px' }}
        name={() => <PlusCircleSvg size={16} color={disableAdd ? '#CCCCCC' : undefined}/>}
      />
      <div style={{  padding: '0 4px' }}>
        <Icon onClick={() => props.onAdd()} size={16} name="minus" style={{ transform: 'rotate(90deg)', color: '#f0f0f0' }}/>
      </div>
      <Icon name="trash-o" onClick={disableDelete ? undefined : props.onDelete} size={17} color={disableDelete ? '#CCCCCC' : undefined}/>
    </Box>
  )
}

interface PeriodSelectorProps {
  value: {
    startTime: string;
    endTime: string;

  }[]
  onChange: (val: PeriodSelectorProps['value']) => void
}
const PeriodSelector = (props:PeriodSelectorProps) => {
  const timeList = props.value || []
  const timeCount = timeList.length
  const { t } = useTranslation()

  function handleChange (newTime: {
    startTime: string;
    endTime: string;

  }, index:number) {
    if (newTime.startTime === newTime.endTime) {
      warningToast(t('e_pc_same_time', '生效时段不能相同'))
      return
    }
    const newTimes = [...timeList]
    newTimes[index] = newTime
    props.onChange(newTimes)
  }

  function handleDelete (index: number) {
    const newTimes = [...timeList]
    newTimes.splice(index, 1)
    props.onChange(newTimes)
  }


  return (
    <div>
      {
        timeList.map((item, index) =>
          <div style={{ paddingBottom: '10px' }} key={`${item}_${index}`} >
            <TimeRange
              value={item}
              disableDelete={timeList.length === 1}
              disableAdd={timeCount === 3}
              onChange={newTime => {handleChange(newTime, index)}}
              onDelete={() => handleDelete(index)}
              onAdd={() => {
                timeList.splice(index + 1, 0, { startTime: '', endTime: '' })
                props.onChange([...timeList])
              }}
            />
          </div>
        )
      }
    </div>
  )
}


export default PeriodSelector